// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChooseLayout_wrapper__3oDID","squares":"ChooseLayout_squares__1b9xS","select":"ChooseLayout_select__1u_5t"};